import { useState, useEffect } from "react";
import { useChatContext } from "stream-chat-react";

export const useUnreadFromChannels = ({
  channelUrls,
  queryOptions,
}: {
  channelUrls: string[];
  queryOptions: {
    limit: number;
    watch?: boolean;
  };
}) => {
  const { client } = useChatContext();
  const validChannelUrls = channelUrls.filter(Boolean);
  const channelUrlsAsString = JSON.stringify(validChannelUrls);
  const [channelUnreadMap, setChannelUnreadMap] = useState<
    Record<string, number>
  >({});

  useEffect(() => {
    const getAndSetChannelUnread = async (userId: string) => {
      const queriedChannels = await client.queryChannels(
        {
          id: { $in: validChannelUrls },
          members: { $in: [client.userID!] },
        },
        [],
        { watch: false, ...queryOptions }
      );

      const unreadMap = queriedChannels.reduce((acc, channel) => {
        const unreadCount = channel.countUnread();
        return { ...acc, [channel.id!]: unreadCount };
      }, {} as Record<string, number>);

      setChannelUnreadMap((v) => ({ ...(v || {}), ...unreadMap }));
    };

    if (client.userID && validChannelUrls.length > 0) {
      getAndSetChannelUnread(client.userID);
    }
  }, [channelUrlsAsString]);

  return channelUnreadMap;
};
